import { SiteUrlModel, SubMenuData } from '../store/manager/state'

export abstract class SiteUrlModelFactory {
  readonly modelString
  readonly subMenuData: SubMenuData

  protected constructor(modelString: string, subMenuData: SubMenuData) {
    this.modelString = modelString
    this.subMenuData = subMenuData
  }

  abstract get protocol(): string

  abstract get domain(): string

  abstract get path(): string

  abstract get isAccessible(): boolean

  create(): SiteUrlModel {
    return {
      modalName: this.modelString,
      url: this.protocol + '://' + this.domain + this.path,
      isAccessible: this.isAccessible
    }
  }
}

/**
 * 記事詳細のURLを表示するときに使うModelを作成するFactory
 */
export class ArticleDetailUrlFactory extends SiteUrlModelFactory {
  constructor(modelString: string, subMenuData: SubMenuData) {
    super(modelString, subMenuData)
  }

  get protocol(): string {
    return this.subMenuData.protocol
  }

  get domain(): string {
    return this.subMenuData.domain
  }

  get path(): string {
    return this.subMenuData.contentDetailPrefixPath + this.subMenuData.contentId
  }

  get isAccessible(): boolean {
    return this.subMenuData.isPublished && this.subMenuData.status === 'published'
  }
}

/**
 * 記事一覧のURLを表示するときに使うModelを作成するFactory
 */
export class ArticleListUrlFactory extends SiteUrlModelFactory {
  constructor(modelString: string, subMenuData: SubMenuData) {
    super(modelString, subMenuData)
  }

  get protocol(): string {
    return this.subMenuData.protocol
  }

  get domain(): string {
    return this.subMenuData.domain
  }

  get path(): string {
    return this.subMenuData.siteItemInfo.pagePath
  }

  get isAccessible(): boolean {
    return this.subMenuData.isPublished && this.subMenuData.siteItemInfo.isPublished
  }
}
